<script>
export default {
    name: 'IlluEvolution',
    props: {
        primaryColor: {
            type: String,
            default: '#31A4A7'
        },

        secondaryColor: {
            type: String,
            default: '#313132'
        },
    }
}
</script>
<template>
    <svg
        class="base-illu illu-evolution"
        width="64"
        height="64"
        viewBox="0 0 64 64"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g fill="none" fill-rule="evenodd">
            <path
                :fill="primaryColor" class="primary-color"
                d="M50.057 14l5.65 5.657-1.415 1.414L51 17.78V36H41v10H31v10H19v-2h10V44h10V34h10V17.883l-3.186 3.188-1.414-1.414L50.05 14z"
            />
            <path
                d="M22 23.373c-3.16 0-6.08 1.049-8.446 2.823-2.399 1.8-4.229 4.346-5.163 7.305a14.646 14.646 0 005.164 7.303A14.022 14.022 0 0022 43.627c3.16 0 6.079-1.048 8.445-2.823 2.4-1.8 4.23-4.346 5.164-7.304a14.646 14.646 0 00-5.164-7.304A14.022 14.022 0 0022 23.373zm0-15c-1.517 0-2.89.63-3.883 1.645A5.677 5.677 0 0016.504 14c0 1.555.616 2.963 1.613 3.982A5.415 5.415 0 0022 19.627c1.516 0 2.889-.63 3.883-1.645A5.677 5.677 0 0027.495 14a5.677 5.677 0 00-1.612-3.982A5.415 5.415 0 0022 8.373z"
                :stroke="secondaryColor" class="secondary-color"
                stroke-width=".747"
            />
        </g>
    </svg>
</template>
